/** Localized short units for counts; spaces stay attached to their numbers. */
export const countFormatCopy = {
  en: {
    thousand: '{{value}}k',
    million: '{{value}}M',
    billion: '{{value}}B',
    trillion: '{{value}}T',
  },
  sk: {
    thousand: '{{value}}\u00a0tis.',
    million: '{{value}}\u00a0mil.',
    billion: '{{value}}\u00a0mld.',
    trillion: '{{value}}\u00a0bil.',
  },
  cs: {
    thousand: '{{value}}\u00a0tis.',
    million: '{{value}}\u00a0mil.',
    billion: '{{value}}\u00a0mld.',
    trillion: '{{value}}\u00a0bil.',
  },
} as const;
